import * as React from 'react';
import cn from 'classnames';
import * as Styles from '@components/atoms/Icon/Icon.module.scss';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

export const PinIcon = ({ fill = 'gcBlue', size = 'small' }: IconProps) => {
    const fillStyles = cn(Styles[fill], Styles.fill);
    return (
        <svg
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width={IconSizes[size]}
            height={IconSizes[size]}
            viewBox="0 0 24 24"
        >
            <title>Pin Icon</title>
            <path
                d="M12 1C7.02944 1 3 5.02944 3 10C3 12.9862 4.21299 14.9212 7.31239 18.0175L8.33276 19.0251C9.81752 20.498 10.5944 21.4249 11.1056 22.4472C11.4741 23.1843 12.5259 23.1843 12.8944 22.4472C13.3755 21.4851 14.092 20.6074 15.4125 19.2795L16.3818 18.3209C19.7075 15.0449 21 13.0826 21 10C21 5.02943 16.9706 1 12 1ZM12 3C15.866 3 19 6.134 19 10C19 12.2169 18.0732 13.767 15.5281 16.347L14.3398 17.5249L13.9785 17.8851C13.2513 18.6168 12.6829 19.2342 12.2213 19.8184L11.999 20.108L11.9469 20.0361C11.4568 19.3868 10.8395 18.7083 10.0215 17.8851L9.02176 16.8961C6.05901 13.9776 5 12.3698 5 10C5 6.134 8.134 3 12 3ZM12 5.5C9.79083 5.5 8 7.29085 8 9.5C8 11.7092 9.79082 13.5 12 13.5C14.2092 13.5 16 11.7092 16 9.5C16 7.29085 14.2092 5.5 12 5.5ZM12 7.5C13.1046 7.5 14 8.39541 14 9.5C14 10.6046 13.1046 11.5 12 11.5C10.8954 11.5 10 10.6046 10 9.5C10 8.39541 10.8954 7.5 12 7.5Z"
                className={fillStyles}
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};
